import type { ApiEndpointKey, ApiEndpointArgs } from './types';

import { API_ENDPOINTS } from './endpoints';

export function buildApiEndpoint<K extends ApiEndpointKey>(key: K, ...[params]: ApiEndpointArgs<K>): string {
  let url: string = API_ENDPOINTS[key];

  if (params) {
    for (const [p, value] of Object.entries(params)) {
      url = url.replace(`:${p}`, String(value));
    }
  }

  return url;
}
